import React from "react";
import moment from "moment";
import styles from "./styles.module.scss";
import { MoveRightIcon } from "../../../../../../../assets/Icons/MoveRightIcon";
import { useCurrentUserQuery } from "../../../../../../../api/queries/useUserQuery";
import { BI_GIFT_CARD_HISTORY_CHANGE_TYPES } from "../../../../../../../api/businessInsight/useBiGiftCardHistoryQuery";
import { DEFAULT_DATE_FORMAT } from "../../../../../../../consts/general";

export const ChangePreview = ({ type, before, after }) => {
  const { data: user } = useCurrentUserQuery();

  const formatDate = (date) =>
    moment(date).format(user?.previewDateFormat || DEFAULT_DATE_FORMAT);

  const isDateChange = type === BI_GIFT_CARD_HISTORY_CHANGE_TYPES.expireCard;

  const formattedBefore = isDateChange
    ? formatDate(before)
    : `${user?.currencySymbol}${before}`;
  const formattedAfter = isDateChange
    ? formatDate(after)
    : `${user?.currencySymbol}${after}`;

  return (
    <div className={styles.root}>
      {formattedBefore} <MoveRightIcon width="14px" /> {formattedAfter}
    </div>
  );
};
